import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import Loading from 'components/Loading'
import { queryBillInfo, languageChange } from 'store/siteConfig'

export default function(route) {
  const Fine = Loadable({
    loader: () => import('./Fine'),
    render(loaded, props) {
      const Component = connect(
        state => ({
          utilityParkingFineState: state.utilityParkingFineState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          queryBillInfo,
          languageChange
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/fine`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Fine {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
